
const Nss = () => {
  return (
    <div className="main-body">
      <div>
        <section className="in-banner">
          <div className="inheading">
            <h1>Community Outreach Programs (NSS)</h1>
          </div>
        </section>
        <div className="breed-crum-div-wrap">
          <div className="breed-crum-div">
            <ol className="breadcrumb">
              <li>
                <a href="/" className="external none">
                  Home
                </a>
                <span> | </span>
              </li>
              <li>
                <a href="/events" className="external none">
                  EVENTS
                </a>
                <span> | </span>
              </li>
              <li>
                <a href="/events/nss" className="external none">
                  NSS
                </a>
              </li>
            </ol>
          </div>
        </div>
        <div className="contentarea">
          <div className="sub-contentarea">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-md-4">
                <img
                  decoding="async"
                  src="https://campus.acetians.in/custom/images/nss1.png"
                  alt
                  style={{ width: "100%" }}
                />
              </div>
              <div className="col-md-8" style={{ margin: "auto" }}>
                <div>
                  <p>
                    <b>Introduction: </b>The National Service Scheme (NSS) is a
                    Central Sector Scheme of Government of India, Ministry of
                    Youth Affairs &amp; Sports. It provides opportunity to the
                    student youth of 11th &amp; 12th Class of schools at +2
                    Board level and student youth of Technical Institution,
                    Graduate &amp; Post Graduate at colleges and University
                    level of India to take part in various government led
                    community service activities &amp; programmes. The sole aim
                    of the NSS is to provide hands on experience to young
                    students in delivering community service. Since inception of
                    the NSS in the year 1969, the number of students strength
                    increased from 40,000 to over 3.8 million up to the end of
                    March 2018 students in various universities, colleges and
                    Institutions of higher learning have volunteered to take
                    part in various community service programmes.{" "}
                  </p>
                  <br />
                  <p>
                    All the youth volunteers who opt to serve the nation through
                    the NSS led community service wear the NSS badge with pride
                    and a sense of responsibility towards helping needy. The
                    Konark wheel in the NSS badge having 8 bars signifies the 24
                    hours of a the day, reminding the wearer to be ready for the
                    service of the nation round the clock i.e. for 24 hours. Red
                    colour in the badge signifies energy and spirit displayed by
                    the NSS volunteers. The Blue colour signifies the cosmos of
                    which the NSS is a tiny part, ready to contribute its share
                    for the welfare of the mankind.
                  </p>
                  <br />
                  <p>
                    <b>Motto: </b>
                    The motto of National Service Scheme is{" "}
                    <b> NOT ME BUT YOU </b>
                    <br />
                    <b>Benefits of Being a NSS Volunteer:</b>A NSS volunteer who
                    takes part in the community service programme would either
                    be a college level or a senior secondary level student.
                    Being an active member these student volunteers would have
                    the exposure and experience to be the following:
                  </p>
                  <ul>
                    <li>an accomplished social leader</li>
                    <li>an efficient administrator</li>
                    <li>a person who understands human nature</li>
                  </ul>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row col-md-12  d-flex">
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg1.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg1.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg2.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg2.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg3.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg3.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg4.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg4.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg5.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg5.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg6.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg6.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg7.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg7.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg8.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg8.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg9.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg9.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg10.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg10.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg11.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg11.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg12.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg12.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
            <div className="col-md-3">
              <div style={{ padding: 10 }}>
                <a
                  href="https://campus.acetians.in/custom/images/nssimg13.jpg"
                  target="_blank"
                >
                  <img
                    src="https://campus.acetians.in/custom/images/nssimg13.jpg"
                    style={{ width: "100%", maxHeight: 300 }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nss;
